import React from "react";
import Button from "../../../../../Other/element/Button";
const CourseBuilderTopbar = ({ handleExit, current }) => {
  return (
    <>
      <div className="button-div">
        {current === 24 ? (
          <></>
        ) : (
          <div className="button-exit-container">
            <Button
              className="btn mar-right-10 nextbutton upper"
              handleClick={handleExit}
              type="submit"
              title="Exit"
            />

            <div className="clear"></div>
          </div>
        )}
      </div>
    </>
  );
};
export default CourseBuilderTopbar;
